import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { browserHistory } from 'react-router';
import autoBind from 'react-autobind';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import baseTheme from 'material-ui/styles/baseThemes/lightBaseTheme';
import TextField from 'material-ui/TextField';
import RaisedButton from 'material-ui/RaisedButton';
import { cyan900 } from 'material-ui/styles/colors';

const propTypes = {
  catalog: PropTypes.any,
};


class ViewCatalog extends Component {
  constructor(props) {
    super(props);
    this.state = {
      catalog: {
        id: 0,
        name: '',
        description: '',
      },
      open: false,
      tenant: '',
    };
    autoBind(this);
  }
  getChildContext() {
    return { muiTheme: getMuiTheme(baseTheme) };
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.catalog) {
      this.setState({
        catalog: nextProps.catalog,
        tenant: nextProps.tenant,
      });
    }
  }
  handleCancel() {
    this.setState({
      open: false,
      assignedOnly: false,
    });
    browserHistory.push('/catalogs?page=1');
  }
  navigateToEdit() {
    const { catalog } = this.props;
    catalog.assignedOnly = false;
    this.setState({ catalog });
    browserHistory.push(`/catalogs/${this.state.catalog.id}`);
  }
  render() {
    const displayOrder = (this.state.catalog.setDisplayOrder === 'alpha') ? 'Alpha-A-Z' : 'User Defined';
    const styles = {
      floatingLabelStyle: {
        color: cyan900,
      },
      inputStyle: {
        marginRight: '2%',
        width: '250px',
      },
    };
    return (
      <div>
        <div className="float-right">
          <RaisedButton
            style={{ marginRight: '20px' }}
            label="Cancel"
            primary
            onClick={this.handleCancel}
          />
          <RaisedButton
            label="Edit"
            primary
            onClick={this.navigateToEdit}
          />
          {/* <SelectField
            value={this.state.categoryFilter}
            onChange={(event, index, value) => this.handleFilterChange(event, index, value)}
            floatingLabelText="Filter by Category"
            style={{ verticalAlign: 'bottom', marginRight: '2%', width: '250px', float: 'right' }}
            name="categoryFilter"
            floatingLabelStyle={styles.floatingLabelStyle}
          >
            {categorySelect}
          </SelectField> */}
        </div>
        <br />
        <TextField
          floatingLabelText="ID"
          floatingLabelStyle={styles.floatingLabelStyle}
          inputStyle={styles.inputStyle}
          value={this.state.catalog.id}
        />
        <br />
        <TextField
          floatingLabelText="Name"
          floatingLabelStyle={styles.floatingLabelStyle}
          value={this.state.catalog.name}
          name="name"
          style={styles.inputStyle}
        />
        <TextField
          floatingLabelText="Description"
          floatingLabelStyle={styles.floatingLabelStyle}
          value={this.state.catalog.description}
          name="description"
          style={styles.inputStyle}
          multiLine={true}
        />
        <TextField
          floatingLabelText="Product Display Order"
          floatingLabelStyle={styles.floatingLabelStyle}
          value={displayOrder}
          name="setDisplayOrder"
          style={styles.inputStyle}
        />
      </div>
    );
  }
}

ViewCatalog.childContextTypes = {
  muiTheme: PropTypes.object.isRequired,
};

ViewCatalog.propTypes = propTypes;

function mapStateToProps(state) {
  return {
    catalog: state.catalogs.catalog,
  };
}

export default connect(mapStateToProps)(ViewCatalog);



// WEBPACK FOOTER //
// ./src/components/catalogs/ViewCatalog.js